"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;
var _StateHelper = _interopRequireDefault(require("../helpers/StateHelper.js"));
var _ClassReport = _interopRequireDefault(require("../factories/ClassReport.js"));
var _constants = require("../constants");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var stateHelper = new _StateHelper.default(_ClassReport.default);
var initialState = stateHelper.initialState;
exports.initialState = initialState;
var reducers = {};
reducers[_constants.CLASS_REPORT_FETCHED] = function (state, payload) {
  return state.withMutations(function (newState) {
    newState.set("".concat(payload.report_id, "-").concat(payload.class_id), new _ClassReport.default({
      id: "".concat(payload.report_id, "-").concat(payload.class_id),
      attributes: {
        class_id: payload.class_id,
        report_id: payload.report_id,
        status: payload.status,
        national_median_all: payload.national_median_all,
        national_median_test: payload.national_median_test,
        org_median_all: payload.org_median_all,
        org_median_test: payload.org_median_test,
        peer_results_all: payload.peer_results_all,
        peer_results_test: payload.peer_results_test,
        report_data: payload.report_data
      },
      relationships: {
        organization: {
          data: {
            id: payload.organization_id
          }
        }
      }
    }));
  });
};
var _default = exports.default = stateHelper.createReducer(reducers);